import React, {useEffect, useState} from 'react'
import {Circle, Layer, Line, Shape, Stage} from "react-konva";
import Konva from "konva";
import KonvaEventObject = Konva.KonvaEventObject;

const anchorDetail = {
    x: 0,
    y: 0,
    radius: 0,
    stroke: '#666',
    fill: '#ddd',
    strokeWidth: 2,
}

// Refer this https://konvajs.org/docs/sandbox/Modify_Curves_with_Anchor_Points.html to fix issues in this component
const LinePointsAnchor = () => {
    const stageRef = React.useRef(null);
    const layerRef = React.useRef(null);
    const [quad, setQuad] = useState(null);
    const [bezier, setBezier] = useState(null);

    useEffect(() => {
        // special objects to save references to anchors
        const tempQuad = {
            start: buildAnchor(60, 30),
            control: buildAnchor(240, 110),
            end: buildAnchor(80, 160),
        };

        const tempBezier = {
            start: buildAnchor(280, 20),
            control1: buildAnchor(530, 40),
            control2: buildAnchor(480, 150),
            end: buildAnchor(300, 150),
        };

        setQuad(tempQuad);
        setBezier(tempBezier);

        updateDottedLines();
    });

    const buildAnchor = (x, y) => {
        let anchor = Circle({
            x: x,
            y: y,
            radius: 0,
            stroke: '#666',
            fill: '#ddd',
            strokeWidth: 2,
            onMouseOver(event: KonvaEventObject<MouseEvent>) {
                document.body.style.cursor = 'pointer';
                this.strokeWidth(4)
            },
            onMouseOut(event: Konva.KonvaEventObject<MouseEvent>) {
                document.body.style.cursor = 'default';
                this.strokeWidth(2);
            },
            onDragMove(event: Konva.KonvaEventObject<DragEvent>) {
                updateDottedLines();
            }
        });

        layerRef.current.add(anchor);
        return anchor;
    }

    // function to update line points from anchors
    const updateDottedLines = () => {
        let q = quad;
        let b = bezier;

        const layer = layerRef.current;

        let quadLinePath = layer.findOne('#quadLinePath');
        let bezierLinePath = layer.findOne('#bezierLinePath');

        quadLinePath.points([
            q.start.x(),
            q.start.y(),
            q.control.x(),
            q.control.y(),
            q.end.x(),
            q.end.y(),
        ]);

        bezierLinePath.points([
            b.start.x(),
            b.start.y(),
            b.control1.x(),
            b.control1.y(),
            b.control2.x(),
            b.control2.y(),
            b.end.x(),
            b.end.y(),
        ]);
    }

    return (
        <>

            <Stage width={window.innerWidth * 3 / 4} height={window.innerHeight * 3 / 4}
                   ref={stageRef}
                   className="">
                <Layer ref={layerRef}>
                    <Shape
                        stroke={'red'}
                        strokeWidth={4}
                        sceneFunc={(context, shape) => {
                            context.beginPath();
                            context.moveTo(quad.start.x(), quad.start.y());
                            context.lineTo(220, 80);
                            context.quadraticCurveTo(quad.control.x(),
                                quad.control.y(),
                                quad.end.x(),
                                quad.end.y());
                            context.fillStrokeShape(shape);
                        }}/>

                    <Shape
                        stroke={'blue'}
                        strokeWidth={5}
                        sceneFunc={(context, shape) => {
                            context.beginPath();
                            context.moveTo(bezier.start.x(), bezier.start.y());
                            context.bezierCurveTo(
                                bezier.control1.x(),
                                bezier.control1.y(),
                                bezier.control2.x(),
                                bezier.control2.y(),
                                bezier.end.x(),
                                bezier.end.y()
                            );
                            context.fillStrokeShape(shape);
                        }}/>

                    <Line
                        dash={[10, 10, 0, 10]}
                        strokeWidth={3}
                        stroke={'black'}
                        lineCap={'round'}
                        id={'quadLinePath'}
                        opacity={0.3}
                        points={[0, 0]}/>

                    <Line dash={[10, 10, 0, 10]}
                          strokeWidth={3}
                          stroke={'black'}
                          lineCap={'round'}
                          id={'bezierLinePath'}
                          opacity={0.3}
                          points={[0, 0]}/>
                </Layer>
            </Stage>

        </>
    )
}

export default LinePointsAnchor
